var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ContentLayout", {
    attrs: {
      title: _vm.$t("label_essweb_attendanceInternal_list_title"),
      pad: "0",
      filterable: "",
    },
    on: {
      activated: _vm.activated,
      filter: function (val) {
        _vm.filterPageData = val
      },
    },
    scopedSlots: _vm._u([
      {
        key: "nav-actions",
        fn: function () {
          return [
            _vm.hasBtn("unlock-admin-internal-attendance-record")
              ? _c(
                  "v-tooltip",
                  {
                    attrs: { bottom: "" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "activator",
                          fn: function (ref) {
                            var on = ref.on
                            var attrs = ref.attrs
                            return [
                              _c(
                                "v-btn",
                                _vm._g(
                                  _vm._b(
                                    {
                                      staticClass:
                                        "mr-2 text-capitalize primary",
                                      attrs: {
                                        color: "white",
                                        loading: _vm.lockloading,
                                        icon: "",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.batchLock(0)
                                        },
                                      },
                                    },
                                    "v-btn",
                                    attrs,
                                    false
                                  ),
                                  on
                                ),
                                [
                                  _c(
                                    "i",
                                    { staticClass: "material-icons-round" },
                                    [_vm._v("lock_open")]
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2894808742
                    ),
                  },
                  [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "message_essweb_attendanceRecord_list_tools_batchUnLockTip"
                          )
                        )
                      ),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm.hasBtn("lock-admin-internal-attendance-record")
              ? _c(
                  "v-tooltip",
                  {
                    attrs: { bottom: "" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "activator",
                          fn: function (ref) {
                            var on = ref.on
                            var attrs = ref.attrs
                            return [
                              _c(
                                "v-btn",
                                _vm._g(
                                  _vm._b(
                                    {
                                      staticClass:
                                        "mr-2 text-capitalize primary",
                                      attrs: {
                                        color: "white",
                                        icon: "",
                                        loading: _vm.lockloading2,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.batchLock(1)
                                        },
                                      },
                                    },
                                    "v-btn",
                                    attrs,
                                    false
                                  ),
                                  on
                                ),
                                [
                                  _c(
                                    "i",
                                    { staticClass: "material-icons-round" },
                                    [_vm._v("lock")]
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1264194302
                    ),
                  },
                  [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "message_essweb_attendanceRecord_list_tools_batchLockTip"
                          )
                        )
                      ),
                    ]),
                  ]
                )
              : _vm._e(),
          ]
        },
        proxy: true,
      },
      {
        key: "top-selection",
        fn: function (ref) {
          var filter = ref.filter
          return [
            _c("Selections2", {
              attrs: { objects: _vm.filterObjects, "small-chip": "" },
              on: {
                close: function ($event) {
                  _vm.filterable = !_vm.filterable
                },
                filter: function ($event) {
                  filter()
                  _vm.toFilter(1, filter)
                },
                update: function (prop, value, selected) {
                  _vm.$fliterValue(_vm.filterObjects, prop, value, selected)
                },
                reset: function (apply) {
                  _vm.$fliterValue(_vm.filterObjects, null, null)
                  if (apply) {
                    filter()
                    _vm.toFilter(1, filter)
                  }
                },
              },
            }),
          ]
        },
      },
      {
        key: "page-main",
        fn: function () {
          return [
            _c("Tabler", {
              attrs: {
                headers: _vm.headers,
                items: _vm.desserts,
                defaultSelect: _vm.selected,
                showSelect: _vm.showSelect && !_vm.isLoading,
                height: _vm.$vuetify.breakpoint.height - 275 - 48,
                totalCount: _vm.totalCount,
                "filter-page-data": _vm.filterPageData,
                overLoading: "",
              },
              on: {
                select: _vm.onSelect,
                change: function (page, perpage, callback, data) {
                  _vm.getList(data, page, perpage, callback)
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "item.staffid",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c(
                        "div",
                        { staticStyle: { "max-width": "300px" } },
                        [
                          _c(
                            "v-list-item",
                            {
                              staticClass: "pa-0 ma-0",
                              attrs: { dense: "", "two-line": "" },
                            },
                            [
                              _c(
                                "v-list-item-avatar",
                                {
                                  staticClass: "mr-1 my-0 pa-0",
                                  attrs: { size: "36" },
                                },
                                [
                                  _c("StaffAvatar", {
                                    attrs: {
                                      size: "36",
                                      isTemp: item.is_temp,
                                      src: item.staff_avatar,
                                      staff_name: item.preferred_name,
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-list-item-content",
                                [
                                  _c("v-list-item-title", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$getCommonLangValue(
                                          item.preferred_name
                                        )
                                      ) + " "
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "text--secondary text-caption-xs",
                                      },
                                      [_vm._v(" " + _vm._s(item.staff_code))]
                                    ),
                                  ]),
                                  _c("v-list-item-subtitle", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$getCommonLangValue(
                                          item.job_post_name
                                        )
                                      )
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                },
                {
                  key: "item.date",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c("div", { staticClass: "text--primary table-title" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$getDateTime(item.utc_att_date, "YYYY/MM/DD")
                            ) +
                            " "
                        ),
                      ]),
                    ]
                  },
                },
                {
                  key: "item.name",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c("div", { staticClass: "text--primary table-title" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$getCommonLangValue(item.official_shift_name)
                            ) +
                            " "
                        ),
                      ]),
                    ]
                  },
                },
                {
                  key: "item.startTime",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c("div", { staticClass: "text--primary table-title" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$getDateTime(
                                item.official_start_utc_time,
                                "HH:mm"
                              )
                            ) +
                            " "
                        ),
                      ]),
                      _c(
                        "div",
                        { staticClass: "text--secondary table-subtitle" },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$getUtcByCode(item.official_start_time_zone)
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ]
                  },
                },
                {
                  key: "item.endTime",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c("div", { staticClass: "text--primary table-title" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$getDateTime(
                                item.official_end_utc_time,
                                "HH:mm"
                              )
                            ) +
                            " "
                        ),
                      ]),
                      _c(
                        "div",
                        { staticClass: "text--secondary table-subtitle" },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$getUtcByCode(item.official_end_time_zone)
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ]
                  },
                },
                {
                  key: "item.punchInTime",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c("div", { staticClass: "text--primary table-title" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$getDateTime(
                                item.official_punch_in_utc_datetime,
                                "HH:mm"
                              )
                            ) +
                            " "
                        ),
                      ]),
                      _c(
                        "div",
                        { staticClass: "text--secondary table-subtitle" },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$getUtcByCode(
                                  item.official_punch_in_time_zone
                                )
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ]
                  },
                },
                {
                  key: "item.punchOutTime",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c("div", { staticClass: "text--primary table-title" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$getDateTime(
                                item.official_punch_out_utc_datetime,
                                "HH:mm"
                              )
                            ) +
                            " "
                        ),
                      ]),
                      _c(
                        "div",
                        { staticClass: "text--secondary table-subtitle" },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$getUtcByCode(
                                  item.official_punch_out_time_zone
                                )
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ]
                  },
                },
                {
                  key: "item.tag",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c(
                        "div",
                        {
                          staticClass: "d-flex flex-wrap justify-start",
                          staticStyle: { "max-width": "200px" },
                        },
                        [
                          Number(item.is_late)
                            ? _c(
                                "v-chip",
                                {
                                  staticClass: "ma-1 white--text",
                                  attrs: {
                                    small: "",
                                    color: _vm.$getTagColors(
                                      _vm.$card_line_colors,
                                      "is_late_1"
                                    ),
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "label_essweb_system_tag_label_lateLabel"
                                      )
                                    ) +
                                      "(" +
                                      _vm._s(
                                        item.official_total_late_minutes || 0
                                      ) +
                                      " " +
                                      _vm._s(
                                        _vm.$t(
                                          "label_essweb_system_minutesLabel"
                                        )
                                      ) +
                                      ")"
                                  ),
                                ]
                              )
                            : _vm._e(),
                          Number(item.is_ot)
                            ? _c(
                                "v-chip",
                                {
                                  staticClass: "ma-1 white--text",
                                  attrs: {
                                    small: "",
                                    color: _vm.$getTagColors(
                                      _vm.$card_line_colors,
                                      "is_ot_1"
                                    ),
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "label_essweb_system_tag_label_otLabel"
                                      )
                                    ) +
                                      "(" +
                                      _vm._s(
                                        item.official_total_ot_minutes || 0
                                      ) +
                                      " " +
                                      _vm._s(
                                        _vm.$t(
                                          "label_essweb_system_minutesLabel"
                                        )
                                      ) +
                                      ")"
                                  ),
                                ]
                              )
                            : _vm._e(),
                          Number(item.is_early_leave)
                            ? _c(
                                "v-chip",
                                {
                                  staticClass: "ma-1 white--text",
                                  attrs: {
                                    small: "",
                                    color: _vm.$getTagColors(
                                      _vm.$card_line_colors,
                                      "is_early_leave_1"
                                    ),
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "label_essweb_system_tag_label_earlyLeaveLabel"
                                      )
                                    ) +
                                      "(" +
                                      _vm._s(
                                        item.official_total_early_leave_minutes ||
                                          0
                                      ) +
                                      " " +
                                      _vm._s(
                                        _vm.$t(
                                          "label_essweb_system_minutesLabel"
                                        )
                                      ) +
                                      ")"
                                  ),
                                ]
                              )
                            : _vm._e(),
                          Number(item.is_absense)
                            ? _c(
                                "v-chip",
                                {
                                  staticClass: "ma-1 white--text",
                                  attrs: {
                                    small: "",
                                    color: _vm.$getTagColors(
                                      _vm.$card_line_colors,
                                      "is_absense_1"
                                    ),
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "label_essweb_system_tag_label_absenseLabel"
                                      )
                                    )
                                  ),
                                ]
                              )
                            : _vm._e(),
                          Number(item.is_work_from_home)
                            ? _c(
                                "v-chip",
                                {
                                  staticClass: "ma-1 text--primary",
                                  attrs: {
                                    small: "",
                                    color: _vm.$getTagColors(
                                      _vm.$card_line_colors,
                                      "is_work_from_home_1"
                                    ),
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "label_essweb_punchRecord_list_tag_workFromHomeLabbel"
                                      )
                                    )
                                  ),
                                ]
                              )
                            : _vm._e(),
                          Number(item.is_locked)
                            ? _c(
                                "v-chip",
                                {
                                  staticClass: "ma-1 white--text",
                                  attrs: {
                                    small: "",
                                    color: _vm.$getTagColors(
                                      _vm.$card_line_colors,
                                      "is_locked_1"
                                    ),
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "label_essweb_system_tag_label_isLockedLabel"
                                      )
                                    )
                                  ),
                                ]
                              )
                            : _vm._e(),
                          Number(item.is_adhoc)
                            ? _c(
                                "v-chip",
                                {
                                  staticClass: "ma-1 text--primary",
                                  attrs: {
                                    small: "",
                                    color: _vm.$getTagColors(
                                      _vm.$card_line_colors,
                                      "is_adhoc_1"
                                    ),
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "label_essweb_system_tag_label_isAdhocLabel"
                                      )
                                    )
                                  ),
                                ]
                              )
                            : _vm._e(),
                          Number(item.is_missing_punch)
                            ? _c(
                                "v-chip",
                                {
                                  staticClass: "ma-1 white--text",
                                  attrs: {
                                    small: "",
                                    color: _vm.$getTagColors(
                                      _vm.$card_line_colors,
                                      "is_missing_punch_1"
                                    ),
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "label_essweb_system_tag_label_isMissingPunchLabel"
                                      )
                                    )
                                  ),
                                ]
                              )
                            : _vm._e(),
                          Number(item.is_out_of_office)
                            ? _c(
                                "v-chip",
                                {
                                  staticClass: "ma-1 text--primary",
                                  attrs: {
                                    small: "",
                                    color: _vm.$getTagColors(
                                      _vm.$card_line_colors,
                                      "is_out_of_office_1"
                                    ),
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "label_essweb_system_tag_label_isOutOfOfficeLabel"
                                      )
                                    )
                                  ),
                                ]
                              )
                            : _vm._e(),
                          Number(item.is_onDuty)
                            ? _c(
                                "v-chip",
                                {
                                  staticClass: "ma-1 white--text",
                                  attrs: {
                                    small: "",
                                    color: _vm.$getTagColors(
                                      _vm.$card_line_colors,
                                      "is_on_duty_1"
                                    ),
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "label_essweb_system_tag_label_isOnDutyLabel"
                                      )
                                    )
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._l(item.leave_info, function (leave, index) {
                            return _c(
                              "v-chip",
                              {
                                key: "leave--" + index,
                                staticClass: "ma-1",
                                attrs: {
                                  small: "",
                                  outlined: "",
                                  color: leave.color_code,
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$getCommonLangValue(
                                      leave["leave_type_name"]
                                    )
                                  )
                                ),
                              ]
                            )
                          }),
                          _vm._l(item.holiday_info, function (holiday, index) {
                            return _c(
                              "v-chip",
                              {
                                key: "holiday--" + index,
                                staticClass: "ma-1 text--primary",
                                attrs: {
                                  small: "",
                                  color: _vm.$getTagColors(
                                    _vm.$card_line_colors,
                                    "is_holiday_1"
                                  ),
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$getCommonLangValue(
                                      holiday["holiday_name"]
                                    )
                                  )
                                ),
                              ]
                            )
                          }),
                        ],
                        2
                      ),
                    ]
                  },
                },
                {
                  key: "item.workMinute",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _vm._v(
                        _vm._s(item.official_working_minutes || 0) +
                          _vm._s(_vm.$t("label_essweb_system_minutesLabel"))
                      ),
                    ]
                  },
                },
                {
                  key: "item.status",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c(
                        "div",
                        { staticStyle: { "max-width": "20px" } },
                        [
                          _c("svg-icon", {
                            attrs: {
                              size: "18",
                              fill: Number(item.is_onduty)
                                ? "green"
                                : "rgb(228, 228, 228)",
                              iconClass: "LabeledColour",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                },
                {
                  key: "item.action",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c("tableListTools", {
                        attrs: {
                          uuid: item.uuid,
                          viewBtn: _vm.hasBtn("change-admin-internal-shift"),
                          otherBtn: _vm.hasBtn("apply-admin-internal-leave"),
                          otherText:
                            "label_essweb_attendanceInternal_toApplyLeaveLabel",
                          editText:
                            "label_essweb_attendanceInternal_list_tools_changeAttendanceLabel",
                          viewText:
                            "label_essweb_attendanceInternal_list_tools_changeShiftLabel",
                          editBtn: _vm.hasBtn(
                            "change-admin-internal-attendance"
                          ),
                          title: _vm.$t(
                            "label_essweb_attendanceInternal_list_title"
                          ),
                        },
                        on: {
                          view: function ($event) {
                            _vm.toShift(
                              item,
                              _vm.$getDateTime(item.utc_att_date, "YYYY-MM-DD")
                            )
                          },
                          edit: function ($event) {
                            _vm.toAttendance(
                              item,
                              _vm.$getDateTime(item.utc_att_date, "YYYY-MM-DD")
                            )
                          },
                          other: function ($event) {
                            return _vm.toApply(item.staff_uuid)
                          },
                        },
                      }),
                    ]
                  },
                },
              ]),
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "tools-main",
        fn: function () {
          return [
            _c("ShiftDialog", {
              attrs: { show: _vm.showShift, curData: _vm.curData },
              on: {
                close: function ($event) {
                  _vm.showShift = false
                  _vm.nowShow = false
                  _vm.curData = null
                },
                onChange: _vm.controlNav,
                onSubmit: function ($event) {
                  _vm.showShift = false
                  _vm.nowShow = false
                  _vm.curData = null
                  _vm.toFilter(null, function () {})
                },
              },
            }),
            _c("attendanceDialog", {
              attrs: {
                show: _vm.showAttendance,
                curUuid: _vm.Roster_uuid,
                curData: _vm.curData2,
              },
              on: {
                close: function ($event) {
                  _vm.showAttendance = false
                  _vm.nowShow2 = false
                  _vm.Roster_uuid = null
                  _vm.curData2 = null
                },
                onChange: _vm.controlNav2,
                onSubmit: function ($event) {
                  _vm.showAttendance = false
                  _vm.nowShow2 = false
                  _vm.Roster_uuid = null
                  _vm.curData2 = null
                  _vm.toFilter(null, function () {})
                },
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }